"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatAmountFromCents = void 0;
/**
 * Transform cents into euro. Decimal is troncated to 2 digits.
 * If amount is an integer, skip the decimal.
 */
const formatAmountFromCents = (amount, { trimTrailingZero = false } = {}) => {
    if (typeof amount !== 'number' || Number.isNaN(amount)) {
        return undefined;
    }
    const euro = Math.floor(amount) / 100;
    let decimalLength = 0;
    if (euro % 1 !== 0) {
        // The amount has a decimal part
        decimalLength = 2;
        if ((euro * 10) % 1 === 0 && trimTrailingZero) {
            // The amount has a decimal part with a trailing zero that must be trimed
            decimalLength = 1;
        }
    }
    return euro.toFixed(decimalLength);
};
exports.formatAmountFromCents = formatAmountFromCents;
//# sourceMappingURL=formatAmountFromCents.js.map